import { Button, Card, CircularProgress, Grid, Hidden, IconButton, InputLabel, Tooltip } from '@material-ui/core';
import { AddOutlined, InfoOutlined, VisibilityOutlined } from '@material-ui/icons';
import React, { useEffect, useState } from 'react';
import { useCallback } from 'react';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { useHistory, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';

import { ModalFasilitas, ModalMisi, ModalPreviewSec, TableMisi, TablePortfolio, UploadImage } from '../../../components';
import { getDetailAnakPerusahaan, updAnakPerusahaan } from '../../../redux/actions/AnakPerusahaanActions';

const EditAnakPerusahaan = () => {
    const { id } = useParams();
    const history = useHistory();
    const [submit, setSubmit] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showPreviewSec1, setShowPreviewSec1] = useState(false)
    const [showPreviewPorto, setShowPreviewPorto] = useState(false)
    const [showMisi, setShowMisi] = useState(false)
    const [showPortfolio, setShowPortfolio] = useState(false)
    const [params, setParams] = useState({
        subs_name: "",
        subs_logo: "",
        subs_ori: "",
        subs_logo_preview: "",
        subs_img_desktop: "",
        subs_img_desktop_preview: "",
        subs_img_desktop_ori: "",
        subs_img_mobile: "",
        subs_img_mobile_preview: "",
        subs_img_mobile_ori: "",
        desc_img: "",
        desc_img_ori: "",
        desc_img_preview: "",
        desc_title_id: "",
        desc_title_en: "",
        desc_id: "",
        desc_en: "",
        website_link: "",
        address: "",
        telp: "",
        fax: "",
        email: "",
        vision_id: "",
        vision_en: "",
        bg_vision: "",
        bg_vision_ori: "",
        bg_vision_preview: "",
        lat: "",
        lng: "",
        mission: [],
        portfolio: [],
        subs_code: ""
    });
    const [mission, setMission] = useState(null)
    const [portfolio, setPortfolio] = useState(null)
    const handleChange = ({ target: { value, name } }) => {
        setParams((pref) => ({
            ...pref,
            [name]: value
        }));
    };
    const handleFormSubmit = () => {
        setSubmit(true);
        updAnakPerusahaan(params)
            .then(() => {
                showAlert('Data berhasil disimpan', true);
                setSubmit(false);
            })
            .catch((err) => {
                let error = err?.response?.data;
                showAlert(
                    Array.isArray(error?.data)
                        ? error?.data[0]
                        : 'Gagal menyimpan data, coba beberapa saat lagi',
                    false
                );
                setSubmit(false);
            });
    };
    const showAlert = useCallback((text, success) => {
        Swal.fire({
            title: success ? 'Berhasil' : 'Oopss!',
            text: text,
            imageUrl: `/assets/images/icons/${
                success ? 'ic_success' : 'ic_error'
            }.svg`,
            imageWidth: 92,
            imageHeight: 92,
            confirmButtonText: 'Ok',
            confirmButtonColor: '#0083E2'
        }).then((res) => {
            if (res.isConfirmed && success) {
                history.goBack();
            }
        });
    }, [history]);
    const handleChangeFoto = (name, file) => {
        setParams((pref) => ({
            ...pref,
            [name]: file,
            [name+'_preview']: file
        }));
    };
    const handleSaveMisi = (data) => {
        if(data?.idx){
            let cek = params.mission.findIndex(item => item.idx === data.idx);
            let misi = params.mission;
            misi[cek].icon = data?.icon ? data.icon : misi[cek].icon;
            misi[cek].title_id = data.title_id;
            misi[cek].title_en = data.title_en;
            misi[cek].desc_id = data.desc_id;
            misi[cek].desc_en = data.desc_en;
            setParams(pref => ({
                ...pref,
                mission: [...misi]
            }))
            setShowMisi(false)
        } else {
            let newMisi = {
                ...data,
                idx: Math.floor(Math.random() * 100)
            }
            setParams(pref => ({
                ...pref,
                mission: [
                    ...pref.mission,
                    newMisi
                ]
            }))
            setShowMisi(false)
        }
        setMission(null)
    }
    const handleDelMisi = (idx) => {
        let newMission = params.mission.filter(item => item.idx !== idx);
        setParams(pref => ({
            ...pref,
            mission: newMission
        }))
    }
    const handleSavePortfolio = (data) => {
        if(data?.idx){
            let cek = params.portfolio.findIndex(item => item.idx === data.idx);
            let porto = params.portfolio;
            porto[cek].bg_img = data?.bg_img ? data.bg_img : porto[cek].bg_img;
            porto[cek].title_id = data.title_id;
            porto[cek].title_en = data.title_en;
            porto[cek].desc_id = data.desc_id;
            porto[cek].desc_en = data.desc_en;
            setParams(pref => ({
                ...pref,
                portfolio: [...porto]
            }))
            setShowPortfolio(false)
        } else {
            let newPorto = {
                ...data,
                idx: Math.floor(Math.random() * 100)
            }
            setParams(pref => ({
                ...pref,
                portfolio: [
                    ...pref.portfolio,
                    newPorto
                ]
            }))
            setShowPortfolio(false)
        }
        setPortfolio(null)
    }
    const handleDelPortfolio = (idx) => {
        let newPortofolio = params.portfolio.filter(item => item.idx !== idx);
        setParams(pref => ({
            ...pref,
            portfolio: newPortofolio
        }))
    }
    const getData = useCallback(() => {
        setLoading(true);
        getDetailAnakPerusahaan(id)
            .then((res) => {
                let data = res.data?.data;
                if (Object.keys(data).length > 0) {
                    setParams((pref) => ({
                        ...pref,
                        subs_name: data?.subs_name,
                        subs_logo: "",
                        subs_logo_ori: data?.subs_logo_ori,
                        subs_logo_preview: data?.subs_logo,
                        subs_img_desktop: "",
                        subs_img_desktop_preview: data?.subs_img_desktop,
                        subs_img_desktop_ori: data?.subs_img_desktop_ori,
                        subs_img_mobile: "",
                        subs_img_mobile_preview: data?.subs_img_mobile,
                        subs_img_mobile_ori: data?.subs_img_mobile_ori,
                        desc_img: "",
                        desc_img_preview: data?.desc_img,
                        desc_img_ori: data?.desc_img_ori,
                        desc_title_id: data?.desc_title_id,
                        desc_title_en: data?.desc_title_en,
                        desc_id: data?.desc_id,
                        desc_en: data?.desc_en,
                        website_link: data?.website_link,
                        address: data?.address,
                        telp: data?.telp,
                        fax: data?.fax,
                        email: data?.email,
                        vision_id: data?.vision_id,
                        vision_en: data?.vision_en,
                        bg_vision: "",
                        bg_vision_preview: data?.bg_vision,
                        bg_vision_ori: data?.bg_vision_ori,
                        lat: data?.lat,
                        lng: data?.lng,
                        mission: data?.mission,
                        portfolio: data?.portfolio,
                        subs_code: data?.subs_code,
                    }));
                } else {
                    showAlert(
                        'Gagal mengambil detail data anak perusahaan, coba beberapa saat lagi',
                        false
                    );
                }
                setLoading(false);
            })
            .catch((err) => {
                let error = err?.response?.data;
                showAlert(
                    Array.isArray(error?.data)
                        ? error?.data[0]
                        : 'Gagal mengambil detail data anak perusahaan, coba beberapa saat lagi',
                    false
                );
                setLoading(false);
            });
    }, [id, showAlert]);
    useEffect(() => {
        setParams((pref) => ({
            ...pref,
            subs_code: id
        }));
        getData();
    }, [getData, id]);
    return (
        <div className="m-sm-30">
            <Grid container spacing={4} justifyContent="center">
                <Grid item xs={11} md={12}>
                    <h3 className="fw-bold m-0">Edit Anak Perusahaan</h3>
                </Grid>
                <Grid item xs={11} md={12}>
                    <Card elevation={0} className="py-5 px-6 border-radius-0 ">
                        {loading ? (
                            <div className="text-center">
                                <CircularProgress color="primary" size={35} />
                            </div>
                        ) : (
                            <ValidatorForm
                                onSubmit={handleFormSubmit}
                                className="w-full"
                            >
                                <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <UploadImage
                                        uploadFoto={(file) => handleChangeFoto("subs_logo", file)}
                                        label="Unggah Logo"
                                        preview={
                                            params?.subs_logo_preview
                                        }
                                        required={true}
                                        noCrop={true}
                                        formatIcon={true}
                                        note={[
                                            'Format SVG dan WEBP diperbolehkan',
                                            '*Ukuran foto 200 x 200'
                                        ]}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <UploadImage
                                        uploadFoto={(file) => handleChangeFoto("subs_img_desktop", file)}
                                        label="Unggah Foto Untuk Desktop"
                                        preview={
                                            params?.subs_img_desktop_preview
                                        }
                                        required={true}
                                        noCrop={true}
                                        note={[
                                            'Format PNG, WEBP dan JPG diperbolehkan',
                                            '*Ukuran foto 1440 x 617'
                                        ]}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <UploadImage
                                        uploadFoto={(file) => handleChangeFoto("subs_img_mobile", file)}
                                        label="Unggah Foto Untuk Mobile"
                                        preview={
                                            params?.subs_img_mobile_preview
                                        }
                                        required={true}
                                        noCrop={true}
                                        note={[
                                            'Format PNG, WEBP dan JPG diperbolehkan',
                                            '*Ukuran foto 767 x 500'
                                        ]}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <InputLabel
                                        htmlFor="subs_name"
                                        className="mb-4"
                                    >
                                        Nama Perusahaan
                                        <span className="text-danger">*</span>
                                    </InputLabel>
                                    <TextValidator
                                        id="subs_name"
                                        placeholder="Nama Perusahaan"
                                        className="w-full"
                                        variant="outlined"
                                        onChange={handleChange}
                                        type="text"
                                        name="subs_name"
                                        value={params.subs_name || ''}
                                        validators={['required']}
                                        errorMessages={[
                                            'Masukkan Nama Perusahaan terlebih dahulu'
                                        ]}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <InputLabel
                                        htmlFor="website_link"
                                        className="mb-4"
                                    >
                                        URL Website
                                    </InputLabel>
                                    <TextValidator
                                        id="website_link"
                                        placeholder="URL Website"
                                        className="w-full"
                                        variant="outlined"
                                        onChange={handleChange}
                                        type="url"
                                        name="website_link"
                                        value={params.website_link || ''}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <InputLabel
                                        htmlFor="telp"
                                        className="mb-4"
                                    >
                                        Telepon
                                    </InputLabel>
                                    <TextValidator
                                        id="telp"
                                        placeholder="Telepon"
                                        className="w-full"
                                        variant="outlined"
                                        onChange={handleChange}
                                        type="number"
                                        name="telp"
                                        value={params.telp || ''}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <InputLabel
                                        htmlFor="fax"
                                        className="mb-4"
                                    >
                                        Fax
                                    </InputLabel>
                                    <TextValidator
                                        id="fax"
                                        placeholder="Fax"
                                        className="w-full"
                                        variant="outlined"
                                        onChange={handleChange}
                                        name="fax"
                                        value={params.fax || ''}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <InputLabel
                                        htmlFor="email"
                                        className="mb-4"
                                    >
                                        Email
                                    </InputLabel>
                                    <TextValidator
                                        id="email"
                                        placeholder="Email"
                                        className="w-full"
                                        variant="outlined"
                                        onChange={handleChange}
                                        name="email"
                                        type='email'
                                        value={params.email || ''}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <InputLabel
                                        htmlFor="lat"
                                        className="mb-4"
                                    >
                                        Latitude Location
                                    </InputLabel>
                                    <TextValidator
                                        id="lat"
                                        placeholder="Latitude Location"
                                        className="w-full"
                                        variant="outlined"
                                        onChange={handleChange}
                                        type='lat'
                                        name='lat'
                                        value={params.lat || ''}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <InputLabel
                                        htmlFor="lng"
                                        className="mb-4"
                                    >
                                        Longitude Location
                                    </InputLabel>
                                    <TextValidator
                                        id="lng"
                                        placeholder="Longitude Location"
                                        className="w-full"
                                        variant="outlined"
                                        onChange={handleChange}
                                        type='lng'
                                        name='lng'
                                        value={params.lng || ''}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <InputLabel
                                        htmlFor="address"
                                        className="mb-4"
                                    >
                                        Alamat
                                    </InputLabel>
                                    <TextValidator
                                        id="address"
                                        placeholder="Alamat"
                                        className="w-full"
                                        variant="outlined"
                                        onChange={handleChange}
                                        type='text'
                                        name='address'
                                        value={params.address || ''}
                                    />
                                </Grid>
                                <Grid item xs={12} className="mt-6">
                                    <h4 className="font-semibold">Bagian Deskripsi <IconButton onClick={() => setShowPreviewSec1(true)} size='small'><VisibilityOutlined fontSize='small' color='action'></VisibilityOutlined></IconButton></h4>
                                </Grid>
                                <Grid item xs={12}>
                                    <UploadImage
                                        uploadFoto={(file) => handleChangeFoto("desc_img", file)}
                                        label="Unggah Foto"
                                        preview={
                                            params?.desc_img_preview
                                        }
                                        required={true}
                                        noCrop={true}
                                        note={[
                                            'Format PNG, WEBP dan JPG diperbolehkan',
                                            '*Ukuran foto 772 x 579'
                                        ]}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <InputLabel
                                        htmlFor="desc_title_id"
                                        className="mb-4"
                                    >
                                        Judul [ID]{' '}
                                        <span className="text-danger">*</span>
                                        <Tooltip title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Indonesia pada website" placement='top-start' arrow>
                                            <InfoOutlined fontSize='small' color='action'></InfoOutlined>
                                        </Tooltip>
                                    </InputLabel>
                                    <TextValidator
                                        id="desc_title_id"
                                        placeholder="Judul"
                                        className="w-full"
                                        variant="outlined"
                                        onChange={handleChange}
                                        type="text"
                                        name="desc_title_id"
                                        value={params.desc_title_id || ''}
                                        validators={['required']}
                                        errorMessages={[
                                            'Masukkan Judul terlebih dahulu'
                                        ]}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <InputLabel
                                        htmlFor="desc_title_en"
                                        className="mb-4"
                                    >
                                        Judul [EN]{' '}
                                        <span className="text-danger">*</span>
                                        <Tooltip title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Inggris pada website" placement='top-start' arrow>
                                            <InfoOutlined fontSize='small' color='action'></InfoOutlined>
                                        </Tooltip>
                                    </InputLabel>
                                    <TextValidator
                                        id="desc_title_en"
                                        placeholder="Judul"
                                        className="w-full"
                                        variant="outlined"
                                        onChange={handleChange}
                                        type="text"
                                        name="desc_title_en"
                                        value={params.desc_title_en || ''}
                                        validators={['required']}
                                        errorMessages={[
                                            'Masukkan Judul terlebih dahulu'
                                        ]}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <InputLabel
                                        htmlFor="desc_id"
                                        className="mb-4"
                                    >
                                        Deskripsi [ID]{' '}
                                        <span className="text-danger">*</span>
                                        <Tooltip title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Indonesia pada website" placement='top-start' arrow>
                                            <InfoOutlined fontSize='small' color='action'></InfoOutlined>
                                        </Tooltip>
                                    </InputLabel>
                                    <TextValidator
                                        id="desc_id"
                                        placeholder="Deskripsi"
                                        className="w-full"
                                        variant="outlined"
                                        onChange={handleChange}
                                        type="text"
                                        name="desc_id"
                                        value={params.desc_id || ''}
                                        validators={['required']}
                                        errorMessages={[
                                            'Masukkan Deskripsi terlebih dahulu'
                                        ]}
                                        multiline
                                        maxRows={16}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <InputLabel
                                        htmlFor="desc_en"
                                        className="mb-4"
                                    >
                                        Deskripsi [EN]{' '}
                                        <span className="text-danger">*</span>
                                        <Tooltip title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Inggris pada website" placement='top-start' arrow>
                                            <InfoOutlined fontSize='small' color='action'></InfoOutlined>
                                        </Tooltip>
                                    </InputLabel>
                                    <TextValidator
                                        id="desc_en"
                                        placeholder="Deskripsi"
                                        className="w-full"
                                        variant="outlined"
                                        onChange={handleChange}
                                        type="text"
                                        name="desc_en"
                                        value={params.desc_en || ''}
                                        validators={['required']}
                                        errorMessages={[
                                            'Masukkan Deskripsi terlebih dahulu'
                                        ]}
                                        multiline
                                        maxRows={16}
                                    />
                                </Grid>
                                <Grid item xs={12} className="mt-6">
                                    <h4 className="font-semibold">Visi</h4>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <InputLabel
                                        htmlFor="vision_id"
                                        className="mb-4"
                                    >
                                        Visi [ID]{' '}
                                        {/* <span className="text-danger">*</span> */}
                                        <Tooltip title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Indonesia pada website" placement='top-start' arrow>
                                            <InfoOutlined fontSize='small' color='action'></InfoOutlined>
                                        </Tooltip>
                                    </InputLabel>
                                    <TextValidator
                                        id="vision_id"
                                        placeholder="Visi"
                                        className="w-full"
                                        variant="outlined"
                                        onChange={handleChange}
                                        type="text"
                                        name="vision_id"
                                        value={params.vision_id || ''}
                                        // validators={['required']}
                                        errorMessages={[
                                            'Masukkan Visi terlebih dahulu'
                                        ]}
                                        multiline
                                        maxRows={16}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <InputLabel
                                        htmlFor="vision_en"
                                        className="mb-4"
                                    >
                                        Visi [EN]{' '}
                                        {/* <span className="text-danger">*</span> */}
                                        <Tooltip title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Inggris pada website" placement='top-start' arrow>
                                            <InfoOutlined fontSize='small' color='action'></InfoOutlined>
                                        </Tooltip>
                                    </InputLabel>
                                    <TextValidator
                                        id="vision_en"
                                        placeholder="Visi"
                                        className="w-full"
                                        variant="outlined"
                                        onChange={handleChange}
                                        type="text"
                                        name="vision_en"
                                        value={params.vision_en || ''}
                                        // validators={['required']}
                                        errorMessages={[
                                            'Masukkan Visi terlebih dahulu'
                                        ]}
                                        multiline
                                        maxRows={16}
                                    />
                                </Grid>
                                <Grid item xs={12} className="mt-6">
                                    <h4 className="font-semibold">Misi</h4>
                                </Grid>
                                <Grid item xs={12}>
                                    <UploadImage
                                        uploadFoto={(file) => handleChangeFoto("bg_vision", file)}
                                        label="Unggah Latar Foto"
                                        preview={
                                            params?.bg_vision_preview
                                        }
                                        required={true}
                                        noCrop={true}
                                        note={[
                                            'Format PNG, WEBP dan JPG diperbolehkan',
                                            '*Ukuran foto 1440 x 943'
                                        ]}
                                    />
                                </Grid>
                                <Grid item xs={8} md={10} className="flex items-center">
                                    <h5 className="font-semibold">Data Misi</h5>
                                </Grid>
                                <Grid item xs={4} md={2}>
                                    <Hidden xsDown>
                                        <Button
                                            onClick={() => setShowMisi(true)}
                                            type="button"
                                            variant="contained"
                                            color="primary"
                                            className="text-white w-full text-capitalize"
                                            disableElevation
                                        >
                                        <AddOutlined />
                                            Tambah
                                        </Button>
                                    </Hidden>
                                    <Hidden smUp>
                                        <Button
                                            onClick={() => setShowMisi(true)}
                                            type="button"
                                            variant="contained"
                                            color="primary"
                                            className="text-white w-full text-capitalize"
                                            disableElevation
                                            size='small'
                                        >
                                            <AddOutlined />
                                        </Button>
                                    </Hidden>
                                </Grid>
                                <Grid item xs={12}>
                                    <TableMisi
                                        data={params.mission}
                                        handleDelMisi={handleDelMisi}
                                        setMission={setMission}
                                        setShowMisi={setShowMisi}
                                    />
                                </Grid>
                                <Grid item xs={8} md={10} className="mt-6">
                                    <h4 className="font-semibold">Bagian Portfolio <IconButton onClick={() => setShowPreviewPorto(true)} size='small'><VisibilityOutlined fontSize='small' color='action'></VisibilityOutlined></IconButton></h4>
                                </Grid>
                                <Grid item xs={4} md={2}>
                                    <Hidden xsDown>
                                        <Button
                                            onClick={() => setShowPortfolio(true)}
                                            type="button"
                                            variant="contained"
                                            color="primary"
                                            className="text-white w-full text-capitalize"
                                            disableElevation
                                        >
                                        <AddOutlined />
                                            Tambah
                                        </Button>
                                    </Hidden>
                                    <Hidden smUp>
                                        <Button
                                            onClick={() => setShowPortfolio(true)}
                                            type="button"
                                            variant="contained"
                                            color="primary"
                                            className="text-white w-full text-capitalize"
                                            disableElevation
                                            size='small'
                                        >
                                            <AddOutlined />
                                        </Button>
                                    </Hidden>
                                </Grid>
                                <Grid item xs={12}>
                                    <TablePortfolio
                                        data={params.portfolio}
                                        handleDelPortfolio={handleDelPortfolio}
                                        setPortfolio={setPortfolio}
                                        setShowPortfolio={setShowPortfolio}
                                    />
                                </Grid>
                                    <Grid item xs={12}>
                                        <Grid
                                            container
                                            spacing={2}
                                            justifyContent="flex-end"
                                            className="flex-column-reverse flex-md-row"
                                        >
                                            <Grid item xs={12} md={2}>
                                                <Button
                                                    color="primary"
                                                    className="text-primary w-full radius-6 text-capitalize py-2"
                                                    disableElevation
                                                    disabled={submit}
                                                    onClick={() =>
                                                        history.goBack()
                                                    }
                                                >
                                                    Batal
                                                </Button>
                                            </Grid>
                                            <Grid item xs={12} md={2}>
                                                <Button
                                                    type="submit"
                                                    variant="contained"
                                                    color="primary"
                                                    className="text-white w-full radius-6 text-capitalize py-2"
                                                    disableElevation
                                                    disabled={submit}
                                                >
                                                    {submit ? (
                                                        <CircularProgress
                                                            color="primary"
                                                            size={25}
                                                        />
                                                    ) : (
                                                        'Simpan'
                                                    )}
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </ValidatorForm>
                        )}
                    </Card>
                </Grid>
            </Grid>
            <ModalPreviewSec handleClose={() => setShowPreviewSec1(false)} img="/assets/images/illustrations/anak_perusahaan_1.png" open={showPreviewSec1} />
            <ModalPreviewSec handleClose={() => setShowPreviewPorto(false)} img="/assets/images/illustrations/anak_perusahaan_2.png" open={showPreviewPorto} />
            <ModalMisi
                open={showMisi}
                data={mission}
                handleClose={()=>{
                    setMission(null);
                    setShowMisi(false)
                }}
                handleSave={handleSaveMisi}
            />
            <ModalFasilitas
                open={showPortfolio}
                data={portfolio}
                handleClose={()=>{
                    setPortfolio(null);
                    setShowPortfolio(false)
                }}
                handleSave={handleSavePortfolio}
            />
        </div>
    );
};

export default EditAnakPerusahaan;
